
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource

  // 是否播放中
  isPlay: boolean = false

  get Global() {
    return this.$store.$global
  }

  playMusic() {
    if (!this.isPlay) {
      ;(this.$refs['audio'] as any).play()
    } else {
      ;(this.$refs['audio'] as any).pause()
    }
    this.isPlay = !this.isPlay
  }

  handleView() {
    this.$showViewer(this.$images.about_xuantong_tong_tabs_bm_img)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
